import { ServiceIdentifier } from '../service-locator';
import { APIService } from './interfaces';

export * from './interfaces';

export const API_SERVICE = ServiceIdentifier.get<APIService>('APIService');
